import { CssBaseline } from '@material-ui/core/';
import { ThemeProvider } from '@material-ui/core/styles';
import { Suspense, lazy, useEffect } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import AiBotRoute from './AiBotRoute';
import CyberbizRoute from './CyberbizRoute';
import GSSRoute from './GSSRoute';
import MitakeRoute from './MitakeRoute';
import RecurringMessageRoute from './RecurringMessageRoute';
import ShopifyRoute from './ShopifyRoute';
import ShoplineRoute from './ShoplineRoute';
import theme from './app/theme';
import Loading from './components/Loading';
import Notifier from './components/Notifier';
import ErrorPage from './components/errorPage/Container';
import LiffRedirect from './components/liff-redirect/Container';
import RootModal from './components/modal/RootModal';
import InitHelmet from './components/shared/InitHelmet';
import InitI18n from './components/shared/InitI18n';

const NotFound = lazy(() => import('./components/NotFound'));

function App() {
  const history = useHistory();
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === '/') {
      if (window.location.hostname === 'localhost') {
        history.replace(
          `/shopline/${process.env.REACT_APP_ORG_ID || 'undefined'}/step1`,
        );
      } else {
        history.replace('/not-found');
      }
    }
  }, [history, pathname]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Notifier />
      <RootModal />
      <Switch>
        <Route path="/:page">
          <InitI18n />
          <InitHelmet />
          <AiBotRoute />
          <GSSRoute />
          <CyberbizRoute />
          <ShoplineRoute />
          <ShopifyRoute />
          <MitakeRoute />
          <RecurringMessageRoute />
          <Route exact path="/error">
            <ErrorPage />
          </Route>
          <Route exact path="/liff-redirect">
            <LiffRedirect />
          </Route>
        </Route>
        <Suspense fallback={<Loading />}>
          <Route path="*" component={NotFound} />
        </Suspense>
      </Switch>
    </ThemeProvider>
  );
}

export default App;
